<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col md="12" class="text-center py-3 border-bottom">
          <img src="@/assets/images/rush-logo-new.svg" alt="RUSH" class="img-fluid img-logo">
        </b-col>
      </b-row>
    </b-container>
    <b-container class="py-5" v-if="success">
      <b-row>
        <b-col md="12" class="text-center my-5">
          <img src="@/assets/images/green-check.svg" alt="Confirmed Account" class="img-fluid">
        </b-col>
        <b-col md="6" offset-md="3" class="text-center">
          <h1 class="mb-4">Congratulations! Your account has been confirmed.</h1>
          <p class="mb-4">You may now login.</p>
          <b-button tag="a" :href="loginUrl" variant="primary" pill class="py-3 px-4">Login to my Account</b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="height-vh d-flex justify-content-center flex-column" v-else-if="errors">
      <div class="w-100 text-center text-muted">
        {{ errors.errors.message }}
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: "ConfirmedAccount",
  data() {
    return {
      success: false
    }
  },
  computed: {
    ...mapState("auth", ["errors"]),
    loginUrl: {
      get() {
        const cmsUrl = {
          Development: `http://rush-revamp-cms-canary.development.xyz/login/${this.emailValidationCode}`,
          Canary: `http://rush-revamp-cms-canary.loyaltyco.xyz/login/${this.emailValidationCode}`,
          Staging: `https://rush-revamp-cms-staging.loyaltyco.xyz/login/${this.emailValidationCode}`,
          Release: `http://rush-revamp-cms-release.loyaltyco.xyz/login/${this.emailValidationCode}`,
          Production: `https://cms.rush.ph/login/${this.emailValidationCode}`
        }
        return cmsUrl[process.env.VUE_APP_MODE];
      },
      set(url) {
        return url;
      }
    },
    emailValidationCode: {
      get() {
        return this.$route.params.email_validation_code;
      },
      set(code) {
        return code;
      }
    }
  },
  async created() {
    const payload = {
      email_validation_code: this.emailValidationCode
    };
    await this.verifyEmail(payload)
      .then(() => {
        if (!this.errors) this.success = true;
        else this.success = false;
      });
  },
  methods: {
    ...mapActions({
      verifyEmail: 'auth/verifyEmail'
    })
  }
}
</script>

<style lang="scss" scoped>
.img-logo {
  max-width: 80px;
}
h1 {
  font-size: 32px;
  line-height: 42px;
  color: #474747;
}
p {
  font-size: 18px;
  color: #2F3941;
}
.height-vh {
  height: 100vh;
}
</style>